/* global swal angular */
import './style.less';
import { names, deliveryMethods } from '@prolaera/library';

export default function($uibModalInstance, $log, $q, CategoryClass, RegulatorClass, reg_id) {
  'ngInject';
  try {
    const vm = this;

    vm.$onInit = activate;

    vm.close = item => $uibModalInstance.close(item || 'cancel');
    vm.namesDict = names;
    vm.deliveryMethods = deliveryMethods;

    function activate() {
      $log.debug('License Requirements Modal Activated');

      vm.loaded = false;
      vm.error = false;

      $q.all([RegulatorClass.loadRegulators(), CategoryClass.loadCategories()])
        .then(([{ objCurrent: regulators }, { obj: categories }]) => {
          vm.regulator = regulators[reg_id];
          vm.categories = categories;

          vm.loaded = true;
        })
        .catch(error => {
          $log.error(error);
          vm.error = true;
          throw error;
        });
    }
  } catch (error) {
    $log.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/licenseRequirement/index.js